import { useTrainingEnabled, useTranslation } from '@msdk/common'
import { Banner, BannerProps, styled } from '@msdk/ui'
import { ReactNode, useEffect } from 'react'

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
`

const Content = styled('div')`
  display: flex;
  flex-flow: row nowrap;
  flex: 1;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
`

interface Props {
  children?: ReactNode
  onBanner: (banner?: BannerProps) => void
}

export function TrainingWrapper(props: Props) {
  const trainingTenant = useTrainingEnabled()

  const t = useTranslation()

  const title = t('LBL_TRAINING_BANNER_TITLE', 'You are in a Training Environment!')
  const message = t(
    'LBL_TRAINING_BANNER_BODY',
    'Changes made here will not affect live data. Avoid using actual patient data.',
  )

  useEffect(() => {
    if (trainingTenant === true) {
      props.onBanner({ title, message })
    }
    if (trainingTenant === false) {
      props.onBanner(undefined)
    }
  }, [trainingTenant, title, message])

  return (
    <Container>
      {trainingTenant && <Banner squared title={title} message={message} severity="info" variant="filled" />}
      <Content>{props.children}</Content>
    </Container>
  )
}
